export default {"src":"/_next/static/media/use-syncswap.dc55728e.svg","height":147,"width":108,"blurWidth":0,"blurHeight":0};